<template>
    <div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kecamatan</span>
            </div>
            <div class="col-sm-3">
                <select class="form-control">
                    <option>Kode - Kecamatan</option>
                    <option>010 - TINANGGEA</option>
                    <option>011 - LALEMBUU</option>
                    <option>020 - ANDOOLO</option>
                    <option>021 - BUKE</option>
                    <option>030 - PALANGGA</option>
                    <option>031 - PALANGGA SELATAN</option>
                    <option>032 - BAITO</option>
                    <option>040 - LAINEA</option>
                    <option>041 - LAEYA</option>
                    <option>050 - KOLONO</option>
                    <option>060 - LAONTI</option>
                    <option>070 - MORAMO</option>
                    <option>071 - MORAMO UTARA</option>
                    <option>080 - KONDA</option>
                    <option>081 - WOLASI</option>
                    <option>090 - RANOMEETO</option>
                    <option>091 - RANOMEETO BARAT</option>
                    <option>100 - LANDONO</option>
                    <option>101 - MOWILA</option>
                    <option>110 - ANGATA</option>
                    <option>111 - BENUA</option>
                    <option>112 - BASALA</option>
                    <option>113 - ANDOOLO BARAT</option>
                    <option>114 - SABULAKOA</option>
                    <option>115 - KOLONO TIMUR</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kelurahan</span>
            </div>
            <div class="col-sm-3">
                <select class="form-control">
                    <option>Kode - Kelurahan</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tahun Pajak</span>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control">
            </div> 
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Buku</span>
            </div>
            <div class="col-sm-3">
                <select name="buku" id="buku">
                    <option>1</option>
                    <option>1,2</option>
                    <option>1,2,3</option>
                    <option>1,2,3,4</option>
                    <option>1,2,3,4,5</option>
                    <option>2</option>
                    <option>2,3</option>
                    <option>2,3,4</option>
                    <option>2,3,4,5</option>
                    <option>3</option>
                    <option>3,4</option>
                    <option>3,4,5</option>
                    <option>4</option>
                    <option>4,5</option>
                    <option>5</option>
                </select>
            </div>
        </div>
        <br> <br>
        <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-10">
                <div class="form-group">
                    <input type="radio" name="radio" id="sppt" class="with-gap">
                    <label for="sppt">SPPT</label>
                    &nbsp;&nbsp;&nbsp;
                    <input type="radio" name="radio" id="stts" class="with-gap">
                    <label for="stts">STTS</label>
                    &nbsp;&nbsp;&nbsp;
                    <input type="radio" name="radio" id="dhkp" class="with-gap">
                    <label for="dhkp">DHKP</label>
                </div>
            </div>
        </div>
        <br> <hr>
        <div class="row">
            <div class="text-center">
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">check</i>Proses</button>
                &nbsp;
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">clear</i>Batal</button>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
